/** Quem entra em campo na prévia, no treino e na partida (sem three: os roteiros e testes usam também). */
import { NET, STATS, statCaps, type FlightStats, type Position } from "@besenliga/shared";
import type { AthleteSpec } from "@besenliga/athlete-three";
import type { Team, WorldSetup } from "@besenliga/sim";
import { PLAYER_ID, parkedId } from "./ids";

/** Na prévia sem regras a Faísca aparece cedo, para dar para testar a captura sem esperar 3 minutos. */
export const PREVIEW_SPARK_SECONDS = 15;

export type Other = { pos: Position; at: [number, number, number]; team: Team };

/** Os dois times completos (7 × 7) nas posições do treino (casa no lado x < 0). */
const LINEUP: Other[] = [
  { pos: "goleiro", at: [-50, 15, 0], team: "casa" },
  { pos: "artilheiro", at: [-20, 10, -2], team: "casa" },
  { pos: "artilheiro", at: [-12, 9, -12], team: "casa" },
  { pos: "artilheiro", at: [-4, 11, 14], team: "casa" },
  { pos: "batedor", at: [-24, 12, -16], team: "casa" },
  { pos: "batedor", at: [-24, 12, 16], team: "casa" },
  { pos: "cacador", at: [-34, 22, 4], team: "casa" },
  { pos: "goleiro", at: [50, 15, 0], team: "fora" },
  { pos: "artilheiro", at: [14, 9, -12], team: "fora" },
  { pos: "artilheiro", at: [22, 10, 2], team: "fora" },
  { pos: "artilheiro", at: [14, 9, 14], team: "fora" },
  { pos: "batedor", at: [26, 12, -16], team: "fora" },
  { pos: "batedor", at: [26, 12, 16], team: "fora" },
  { pos: "cacador", at: [34, 22, -4], team: "fora" },
];

/** Os outros 13: o seu time sem uma vaga da sua posição, e o adversário completo. */
export function othersFor(role: Position): Other[] {
  const mine = LINEUP.findIndex((o) => o.team === "casa" && o.pos === role);
  return LINEUP.filter((_, i) => i !== mine);
}

/** Atributos a partir do corpo: o teto de cada atributo menos uma margem de evolução. */
export function pilotStats(spec: Pick<AthleteSpec, "sexo" | "altura" | "biotipo">): FlightStats {
  const caps = statCaps({ sex: spec.sexo, height: spec.altura, build: spec.biotipo });
  const stats = {} as FlightStats;
  for (const s of STATS) stats[s] = caps[s] - 15;
  return stats;
}

/** Mundo inicial: você no time da casa e os outros 13. `rules` liga as regras da partida. */
export function previewSetup(role: Position, stats: FlightStats, rules: boolean, seed = 41): WorldSetup {
  return {
    seed,
    ...(rules ? { mode: "partida" as const } : { sparkAtTick: PREVIEW_SPARK_SECONDS * NET.simTickHz }),
    athletes: [
      { id: PLAYER_ID, team: "casa", role, position: { x: -30, y: 10, z: -20 }, stats },
      ...othersFor(role).map((p, i) => ({
        id: parkedId(i),
        team: p.team,
        role: p.pos,
        position: { x: p.at[0], y: p.at[1], z: p.at[2] },
      })),
    ],
  };
}
